import { createContext, useContext, useEffect } from 'react';

import { useId } from '@toolbox/hooks';

type ValuationContext = {
  valuation: string | null;
  loading: boolean;
  registerConsumer?: (id: string) => void;
  unregisterConsumer?: (id: string) => void;
};

export const ValuationContext = createContext<ValuationContext>({
  valuation: null,
  loading: false,
});

export const useValuationContext = (): ValuationContext => {
  const context = useContext(ValuationContext);
  const id = useId();

  useEffect(() => {
    context.registerConsumer?.(id);
    return () => context?.unregisterConsumer?.(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return context;
};

export const ValuationContextProvider = ValuationContext.Provider;
